import { TargetsDependencies, TargetsViewData } from '../../targets/type';
import { TargetsWebComponent } from '../../targets';

export async function renderSelectTargetsComponent(
  targetComponent: TargetsWebComponent,
  targetsViewData: TargetsViewData,
  dependencies
): Promise<void> {
  // start the component
  if (!targetComponent.started) {
    let selectTargetsDependency = {
      translateFn: dependencies.translateFn,
      getUser: dependencies.getUser,
      api: {
        clients: {
          MDM: dependencies.api.clients.MDM,
        },
      },
      isCloud: dependencies.isCloud,
    } as TargetsDependencies;

    targetComponent.injectDependencies(selectTargetsDependency);
    targetComponent.setViewData(targetsViewData);
    await targetComponent.start();
    return;
  }
  // refresh the component
  targetComponent.setViewData(targetsViewData);
  await targetComponent.controller.render();
}
